export enum VerifiedStatus {
  Waiting,
  Failed,
  Pass,
}
